import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { translations } from "@/i18n/translations";

const TopBanner = () => {
  const { t, dir, localePath } = useLanguage();
  const s = t(translations.topBanner);
  const ArrowIcon = ArrowRight;

  return (
    <div className="relative overflow-hidden bg-foreground text-background py-2 px-4 text-center text-xs md:text-sm font-medium">
      <span>{s.text} </span>
      <Link
        to={localePath(s.href)}
        className="underline underline-offset-2 inline-flex items-center gap-1 hover:opacity-80 transition-opacity font-semibold"
      >
        {s.link}
        <ArrowIcon className={`w-3 h-3 ${dir === "rtl" ? "rotate-180" : ""}`} strokeWidth={2} />
      </Link>
    </div>
  );
};

export default TopBanner;
